import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { Phone, Mail } from 'lucide-react';
export function ContactSection() {
  return <section id="enquire" className="py-24 md:py-32 bg-brand-surface relative overflow-hidden" data-id="element-9">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-px h-20 bg-gradient-to-b from-transparent to-brand-gold/40" data-id="element-10"></div>

      <div className="max-w-4xl mx-auto px-6 md:px-12 text-center relative z-10" data-id="element-11">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8,
        ease: [0.16, 1, 0.3, 1]
      }} data-id="element-12">
          <h2 className="font-heading text-5xl md:text-7xl text-white mb-4 uppercase" data-id="element-13">
            Express Your Interest
          </h2>
          <p className="text-brand-muted text-base font-light mb-14 max-w-xl mx-auto" data-id="element-14">
            For private inspections, detailed information memorandums, and to
            discuss this rare commercial opportunity.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: [0.16, 1, 0.3, 1]
      }} className="bg-brand-black border border-white/8 p-10 md:p-14 max-w-lg mx-auto relative" data-id="element-15">
          {/* Corner accents — always visible */}
          <div className="absolute top-0 left-0 w-5 h-5 border-t border-l border-brand-gold/60" data-id="element-16"></div>
          <div className="absolute top-0 right-0 w-5 h-5 border-t border-r border-brand-gold/60" data-id="element-17"></div>
          <div className="absolute bottom-0 left-0 w-5 h-5 border-b border-l border-brand-gold/60" data-id="element-18"></div>
          <div className="absolute bottom-0 right-0 w-5 h-5 border-b border-r border-brand-gold/60" data-id="element-19"></div>

          <div className="mb-8" data-id="element-20">
            <h3 className="font-heading text-4xl text-white mb-1 uppercase" data-id="element-21">
              James Mitchell
            </h3>
            <p className="text-brand-gold tracking-widest uppercase text-xs font-medium mb-8" data-id="element-22">
              Senior Commercial Agent
            </p>

            <div className="space-y-4" data-id="element-23">
              <a href="tel:0400000000" className="flex items-center justify-center gap-3 text-brand-muted hover:text-white transition-colors text-sm" data-id="element-24">
                <Phone size={14} className="text-brand-gold" data-id="element-25" />
                0400 000 000
              </a>
              <a href="mailto:james@morley.com.au" className="flex items-center justify-center gap-3 text-brand-muted hover:text-white transition-colors text-sm" data-id="element-26">
                <Mail size={14} className="text-brand-gold" data-id="element-27" />
                james@morley.com.au
              </a>
            </div>
          </div>

          <a href="mailto:james@morley.com.au?subject=Enquiry%20-%2011%20Northcote%20Street%20Richmond" className="block w-full py-4 bg-brand-gold text-brand-black uppercase tracking-widest text-sm font-semibold hover:bg-white transition-colors duration-300 text-center" data-id="element-28">
            Enquire
          </a>
        </motion.div>
      </div>
    </section>;
}